import { gql } from '@apollo/client';

const UNREVIEWED_REPORT_FRAGMENT = gql`
  fragment UnreviewedReportFragment on Report {
    id
    reportId
    type
    start
    stop
    status
    study {
      id
      friendlyId
      externalSource {
        provider
        externalId
      }
      deviceId
      start
      stop
      status
      reportDueDate
      timezone
      studyTimeOffset
      facility {
        id
        name
        contact {
          country
        }
        arrears
        timezone
      }
      info {
        interprettingPhysician {
          id
          firstName
          lastName
        }
        patient {
          firstName
          lastName
          patientId
        }
      }
      studyType
      timezone
      studyTimeOffset
      isBiofluxDirect
      reports {
        id
        type
        inbox {
          date
        }
      }
      device {
        model
      }
    }
    event {
      id
      friendlyId
      hasClinicData
      comments
    }
    hasSignature
    technicianComments
    physicianInterpretation
    lastModified
    inbox {
      date
      priority
      isReviewed
      isRead
    }
    isArtifactReport
    formatVersion
    aiFormatVersion
    profile
  }
`;

export default UNREVIEWED_REPORT_FRAGMENT;
